import ProductRepairStep from './RepairStep';

export default ProductRepairStep;
